import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

import {
    TextField,
    SimpleShowLayout,
} from 'react-admin';

const StyledSimpleShowLayout = styled(SimpleShowLayout)({
    paddingBottom: '0 !important',
    paddingTop: '0 !important',
});

const TextFieldCustom = (props) => {
    const {
        label,
        record,
        resource,
        source,
    } = props;

    return (
        <StyledSimpleShowLayout record={record} resource={resource}>
            <TextField label={label} source={source} />
        </StyledSimpleShowLayout>
    );
};

TextFieldCustom.propTypes = {
    label: PropTypes.string,
    record: PropTypes.any,
    resource: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
};

export default TextFieldCustom;
